/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { clientsControllerCreate } from "./clientsControllerCreate";
import { clientsControllerFindAll } from "./clientsControllerFindAll";
import { clientsControllerFindOne } from "./clientsControllerFindOne";
import { clientsControllerRemove } from "./clientsControllerRemove";
import { clientsControllerUpdate } from "./clientsControllerUpdate";

export function clientsService() {
  return { clientsControllerCreate, clientsControllerFindAll, clientsControllerFindOne, clientsControllerUpdate, clientsControllerRemove }
}